import actionTypes from '../actionTypes';

export function getRcaData(payload) {
	return {
		type: actionTypes.GET_RCA_DATA,
		payload,
	};
}

export function getRcaDataSuccess(payload) {
	return {
		type: actionTypes.GET_RCA_DATA_SUCCSS,
		payload,
	};
}

export function getRcaDataFailure(payload) {
	return {
		type: actionTypes.GET_RCA_DATA_FAILURE,
		payload,
	};
}

export function updateRcaTableHeadersAndRows(payload) {
	return {
		type: actionTypes.UPDATE_RCA_TABLE_HEADERS_AND_ROWS,
		payload,
	};
}

export function updateInventoryRootCause(payload) {
	return {
		type: actionTypes.UPDATE_INVENTORY_ROOTCAUSE,
		payload,
	};
}

export function updateInventoryRootCauseSuccess(payload) {
	return {
		type: actionTypes.UPDATE_INVENTORY_ROOTCAUSE_SUCCESS,
		payload,
	};
}

export function updateInventoryRootCauseFailure(payload) {
	return {
		type: actionTypes.UPDATE_INVENTORY_ROOTCAUSE_FAILURE,
		payload,
	};
}

export function updateInventoryRootCauseNoDataSuccess(payload) {
	return {
		type: actionTypes.UPDATE_INVENTORY_ROOTCAUSE_NO_DATA_SUCCESS,
		payload,
	}
}


export function setInventoryReplThreshold(payload) {
	return {
		type: actionTypes.SET_INVENTORY_REPL_THRESHOLD,
		payload,
	};
}

export function getRcaBDDMetrics(payload) {
	return {
		type: actionTypes.GET_RCA_BDD_METRICS,
		payload,
	};
}

export function getRcaBDDMetricsSuccess(payload) {
	return {
		type: actionTypes.GET_RCA_BDD_METRICS_SUCCESS,
		payload,
	};
}

export function getRcaBDDMetricsFailure(payload) {
	return {
		type: actionTypes.GET_RCA_BDD_METRICS_FAILURE,
		payload,
	};
}

export function resetRcaLoadingState() {
	return {
		type: actionTypes.RESET_RCA_LOADING_STATE
	};
}
